const getEnvironment = (config) => {
    if (config) {
        return config.env;
    }

    return App.Config.env;
};

export const isBoozt = config => getEnvironment(config) === 'boozt';
export const isBooztmobile = config => getEnvironment(config) === 'booztmobile';
export const isApp = () => typeof App.Config.isApp !== 'undefined' && App.Config.isApp;

export const getStoreEnv = (config) => {
    if (config?.webshop?.id === 'booztlet') {
        return 'booztlet';
    }

    return 'boozt';
};

export const isBooztletAndWebshop = config => getStoreEnv(config) === 'booztlet';
export const getEnvDomain = config => (isBooztletAndWebshop(config) ? 'Booztlet.com' : 'Boozt.com');
export const isBooztAndWebshop = config => getStoreEnv(config) === 'boozt';

/* eslint-disable */
export const isProdEnv = () => ENVIRONMENT === 'production';
export const isDevEnv = () => ENVIRONMENT === 'development';
/* eslint-enable */

export const isStoreBoozt = config => config.webshop.id === 'boozt';
export const isStoreBooztlet = config => config.webshop.id === 'booztlet';
export const getStoreId = config => config.webshop.id;
export const isWebshopDesktop = config => !config.isMobileDevice;
export const isWebshopMobile = config => config.isMobileDevice;
